import { Uom } from "./uom.model";
import { IMarket } from "../interfaces/market.interface";
import { ModelWithUnitsOfMeasure } from "../../providers/utils/uom";

export class Market extends ModelWithUnitsOfMeasure implements IMarket {
  marketname: string;

  constructor(market: IMarket) {
    const uoms = market.uoms.map(uom => new Uom(uom));
    super(uoms);
    Object.keys(market).map(key => this[key] = market[key]);
  }
}